import Head from 'next/head'
import { useTranslation } from '@mc/i18n'
import { SITE_NAME, TWITTER_CARD, TWITTER_HANDLE } from 'libs/constants'

const Meta = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <Head>
      <title>{t('articles.meta.title')}</title>
      <meta
        content={t('articles.meta.description')}
        name='description'
        property='description'
      />
      <meta content={t('articles.meta.keywords')} name='keywords' />
      <meta
        content='https://www.masterclass.com/articles'
        name='og:url'
        property='og:url'
      />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta
        content={t('articles.meta.title')}
        name='og:title'
        property='og:title'
      />
      <meta
        content={t('articles.meta.fbDescription')}
        name='og:description'
        property='og:description'
      />
      <meta
        content={TWITTER_CARD}
        name='twitter:card'
        property='twitter:card'
      />
      <meta
        content={TWITTER_HANDLE}
        name='twitter:site'
        property='twitter:site'
      />
      <meta
        content={t('articles.meta.title')}
        name='twitter:title'
        property='twitter:title'
      />
      <meta
        content={t('articles.meta.fbDescription')}
        name='twitter:description'
        property='twitter:description'
      />
      <meta
        content='https://www.masterclass.com/course-images/attachments/3YXutEJ6FhLmxV6jQb44opCD'
        name='twitter:image'
      />
    </Head>
  )
}

export default Meta
